import type { BreakoutPluginOptions } from '@atlaskit/editor-plugin-breakout';

export function breakoutPluginOptions(): BreakoutPluginOptions {
	return {
		allowBreakoutButton: true,
	};
}
